import React, { useEffect, useState } from "react";
import StateTree from "../../globalHelpers/StateTree";
import { getLanguage } from "../../globalHelpers/LanguageHelper";
// import Express from "../../middleware/middleware_controller";

function T2(props) {
    const [language, setLanguage] = useState(props.language || "en");
    const [label, setLabel] = useState({});
    const [rawText, setRawText] = useState(null);
    const [originalText, setOriginalText] = useState(null);

    useEffect(() => {
        try {
            const cookieLang = getLanguage();
            setLanguage(cookieLang);

            const labelSubscription = StateTree.catalogue("labels").subscribe(
                (results) => {
                    if (!results) return;

                    if (results && results[props.id]) {
                        const origin = { ...results[props.id] };
                        setOriginalText(origin);
                        setLabel(
                            replaceDataField({
                                input: results[props.id],
                                dataFields: props.dataFields,
                            })
                        );
                        return;
                    }

                    setOriginalText({
                        en: props.children + "",
                    });
                    const rawLabel = replaceDataField({
                        input: {
                            en: props.children + "",
                        },
                        dataFields: props.dataFields,
                    });
                    setRawText(rawLabel["en"]);
                }
            );

            const languageSubscription = StateTree.catalogue(
                "language"
            ).subscribe((results) => {
                if (results && results.length > 0) {
                    setLanguage(results);
                    return;
                }

                setLanguage("en");
            });

            return () => {
                labelSubscription.unsubscribe();
                languageSubscription.unsubscribe();
            };
        } catch (e) {
            console.log(e);
        }
    }, []);

    useEffect(() => {
        try {
            if (label && label[props.id]) {
                setLabel(
                    replaceDataField({
                        input: label[props.id],
                        dataFields: props.dataFields,
                    })
                );
                return;
            }

            if (!props.children) {
                setRawText("");
                return;
            }

            const rawLabel = replaceDataField({
                input: {
                    en: props.children + "",
                },
                dataFields: props.dataFields,
            });

            setRawText(rawLabel["en"]);
        } catch (e) {
            console.log(e);
        }
    }, [props.id]);

    useEffect(() => {
        try {
            if (!props.dataFields) return;
            if (!originalText) return;

            const newText = replaceDataField({
                input: originalText,
                dataFields: props.dataFields,
            });

            setLabel(newText);
        } catch (e) {
            console.log(e);
        }
    }, [props.dataFields]);

    function replaceDataField({ input, dataFields }) {
        try {
            if (!input || !dataFields) return input;

            const dataKeys = Object.keys(dataFields);
            const languageKeys = ["en", "es"];

            if (dataKeys.length <= 0) return input;

            const results = { ...input };

            for (let i = 0; i < languageKeys.length; i++) {
                const languageKey = languageKeys[i];
                let labelStr = results[languageKey];

                if (!labelStr) continue;

                for (let a = 0; a < dataKeys.length; a++) {
                    labelStr = results[languageKey];
                    const dataKey = dataKeys[a];
                    const value = dataFields[dataKey];

                    results[languageKey] = labelStr.replaceAll(
                        "${" + dataKey + "}",
                        value
                    );
                }
            }

            return results;
        } catch (e) {
            console.log(e);
            return input;
        }
    }

    if (!label) {
        return "";
    }

    return label[language] || rawText;
}

export default T2;
